import type { FunctionComponent } from 'react'
import 'twin.macro'
import tw, { styled } from 'twin.macro'

export type SimpleAccordionProps = { widgetType?: string; children: any }
const StyledDl = styled.dl<{ widgetType?: string }>(({ widgetType }) => [
  !widgetType || widgetType === 'DefaultAccordion'
    ? tw`divide-y-2 divide-gray-200 border-t-2 border-b-2 border-gray-200`
    : tw`divide-y-0 border-t-0 border-b-0`,
])

export const SimpleAccordion: FunctionComponent<React.PropsWithChildren<SimpleAccordionProps>> = ({
  widgetType,
  children,
}) => {
  return (
    <>
      <StyledDl widgetType={widgetType}>{children}</StyledDl>
    </>
  )
}
